import { authFetch, sapFetch } from "../../api";

export const getUserAcademics = async (payload) => {
  try {
    const response = await authFetch(
      `profile/show-academic-details`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};

export const getCourseLevel = async () => {
  try {
    const response = await authFetch(
      `gradlynk-course-levels/get-course-levels-profile-section`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" }, 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching course level:", err.message);
    throw err;
  }
};

export const getStreams = async (page) => {
  try {
    const response = await sapFetch(
      `get-streams?page=${page}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};
export const getAffiliations = async (page,affiliation_name) => {
  try {
    const response = await sapFetch(
      `get-affiliations?page=${page}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ affiliation_name }),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};

export const getInstitutes = async (pageNum,type,university_name) => {
  let payload = { type ,university_name};
  try {
    const response = await sapFetch(
      `get-institute-for-profile?page=${pageNum}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error fetching academic profile:", err.message);
    throw err;
  }
};

export const saveAcademicDetails = async (payload) => {
  try {
    const response = await authFetch(
      `profile/save-new-academic-details`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to save: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error saving academic details:", err.message);
    throw err;
  }
};

export const updateAcademicDetails = async (payload) => {
  try {
    const response = await authFetch(
      `profile/edit-academic-details`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload), 
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to update: ${response.status}`);
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.error("Error updating academic details:", err.message);
    throw err;
  }
};